import Base from '@studiometa/js-toolkit';
import Rellax from 'rellax';

/**
 * @typedef {Object} ExpertiseRef
 * @property {HTMLElement[]} images[]
 */

/**
 * @typedef {Object} ExpertiseInterface
 * @property {ExpertiseRef} $refs
 * @property {Rellax.RellaxInstance[]} rellaxInstances
 */

/**
 * Homepage class.
 */
export default class Expertise extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Expertise',
    refs: ['images[]'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Expertise & ExpertiseInterface}
   */
  mounted() {
    this.rellaxInstances = [];

    this.$refs.images.forEach((image) => {
      this.rellaxInstances.push(
        new Rellax(image, {
          center: true,
          speed: parseFloat(image.dataset.speed) || -2,
        })
      );
    });
  }
}
